var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "Distributor in Korea",
      "tabActive": "Dupont Kalrez®",
      "bg": "/images/sub/visual/sv3.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', {
    staticClass: "mb-lg-42"
  }, [_c('h2', {
    staticClass: "page-tit mb-18 mb-lg-24"
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "470",
      "src": "/images/logos/kalrez.png",
      "alt": "Dupont Kalrez"
    }
  })], 1), _c('h3', {
    staticClass: "tit text-center primary--text"
  }, [_vm._v("Dupont Kalrez® 공식 대리점")])]), _c('sub-bg-image', {
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-top-img.png",
      "className": "h-lg-280px"
    }
  }, [_c('h3', {
    staticClass: "tit font-weight-semibold mb-8 mb-md-50 mb-lg-100"
  }, [_vm._v(" DUPONT은 약 200년 이상의 "), _c('br'), _vm._v(" 전통을 가진 미국 화학회사 입니다. ")]), _c('p', {
    staticClass: "page-text color-grey-51 mb-2 mb-lg-10"
  }, [_vm._v(" Kalrez® 부품은 항공우주 및 화학 가공에서부터 칩 제조, 석유 및 가스 추출업 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 등 연구를 거듭해 개발한 Metal Sleeve는 10μm 정도의 초박육 설계로, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 이음매가 없는 금속 가공하여, 고성능의 OA 기기에는 꼭 필요한 부품으로 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 큰 점유율을 차지하고 있습니다. ")]), _c('p', {
    staticClass: "page-text color-grey-51"
  }, [_vm._v(" 환경산업과 의료산업 등 향후 성장이 기대되는 분야로 시야를 넓혀 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 독자적인 기술로 확실한 가치와 상품을 제공해 나갈 것입니다. ")])])], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "특장점"
    }
  }, [_c('v-row', [_c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/kalrez/kalrez-icon1.png",
      "iconWidth": "50",
      "num": "01"
    }
  }, [_vm._v(" 다양한 화합물로 이루어진 Kalrez® 부품은 다른 화학 물질과 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 온도에서 견딜 수 있는 특성을 지녀 내화학성에 뛰어납니다. ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/kalrez/kalrez-icon2.png",
      "iconWidth": "38",
      "num": "02"
    }
  }, [_vm._v("내열성이 강하여 금속, 세라믹 및 기타 폴리머를 대체할 수 있는 제품이며 다양한 용도에서 비용 절감과 응용에 최적화된 제품입니다.")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/kalrez/kalrez-icon3.png",
      "iconWidth": "50",
      "num": "03"
    }
  }, [_vm._v(" Kalrez® 제품은 인증 받은 제품으로써 씰 고장 가능성을 줄여 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 급속 가스 감압에 엄격한 요구 조건을 충족시켰습니다. ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/kalrez/kalrez-icon4.png",
      "iconWidth": "50",
      "num": "04"
    }
  }, [_vm._v(" 웨이퍼 수율에는 순도가 매우 중요한 만큼 특수 제작된 Kalrez® "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" FFKM 씰은 입자, 가스 배출 및 추출물로 인한 웨이퍼 오염을 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 줄입니다. ")])], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "Kalrez®"
    }
  }, [_c('p', {
    staticClass: "page-text color-grey-51 mb-30 mb-lg-52"
  }, [_vm._v(" Kalrez®부품은 Dupont Elastomers 社에서 원재료 폴리머에서 고무 성형까지 일관되게 하고 있는 Perfluoro Elastomer "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 부품의 등록 상표이며, 테프론을 고무화 한 제품입니다. 가혹한 환경에서도 내성이 강한 고기능성 고무 재료이며, 정밀도와 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 고성능을 요구하는 모든 산업 분야에서 사용되고 있습니다. ")]), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('table', {
    staticClass: "client-table client-table-lg w-100 border-md-end"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "25%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "75%"
    }
  })]), _c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Plasma Process")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Properties ( 특성 )")])])])]), _c('tbody', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 9600")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· Fluorine 및 Oxygen 계열의 plasma 환경에 대한 저항성이 뛰어난 제품")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· Kalrez® 9500의 장점에 Compression Set 특성을 개선 하였고,CVD/ALD 공정에 특화됨")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 9500")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· 높은 온도에 대해 뛰어난 내열성을 가진 제품")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· Sticking 및 Outgassing 부분을 개선함")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 9300")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· 물리적, 화학적 플라즈마에 대한 균형 잡힌 저항성을 가진 제품")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· 금속 Particle 발생 최소화")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 9100")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· 플라즈마로 인한 Particle 발생 및 Erosion을 최소화한 제품")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· 건식 공정에서 우수한 저항성을 가짐")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 6005")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· Etch, Ashing, Stripping 공정 등에 특화된 제품")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· 높은 온도에서 낮은 Sticking 특성을 가짐")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 8002")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· 산소 및 불소계 플라즈마로 인한 Particle 발생을 최소화한 제품")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· 낮은 영구 압축줄음율을 가짐")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 8085")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· NF3 플라즈마 환경에서 Particle 발생을 최소화한 제품")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· 높은 기계적 강도를 갖도록 고안됨")])])])])])])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('table', {
    staticClass: "client-table client-table-lg w-100 border-md-end"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "25%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "75%"
    }
  })]), _c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Thermal Process")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Properties ( 특성 )")])])])]), _c('tbody', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 8900")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· 높은 온도에 대해 뛰어난 내열성을 가진 제품")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· Sticking 및 Outgassing 부분을 개선함")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 7075")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· 높은 온도에서 기계적 특성을 유지하는 제품")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· 낮은 영구압축줄음률을 가짐")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 8475")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· 적외선 흡수를 감소시켜 Seal 온도 상승을 낮춘 제품")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· Lamp Anneal, RTP Sealing 등에 특화")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 8575")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded mb-2 mb-lg-6"
  }, [_vm._v("· 탄성 회복력을 향상시키고 Outgassing을 개선한 제품")]), _c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· CIF3와 같은 염소계 세정 가스에 대한저항성을 개선")])])])])])])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('table', {
    staticClass: "client-table client-table--last client-table-lg w-100"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "25%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "75%"
    }
  })]), _c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Wet Process")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Properties ( 특성 )")])])])]), _c('tbody', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 6375")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· 모든 습식 화학 공정에 사용")])])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® 4079")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_c('p', {
    staticClass: "dot-txt-rounded"
  }, [_vm._v("· 건식 및 습식 공정에서 범용적으로 사용")])])])])])])])])], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "Kalrez® 재질 특성"
    }
  }, [_c('table', {
    staticClass: "client-table client-table-lg w-100 word-break-word word-sm-keep-all"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® Grade")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Kalrez® Remark")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Color")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Image")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Hardness")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Max Service Temp. ℃(℉)")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Compression Set at 70hr204℃, %")])])])]), _c('tbody', [_c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("9600")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("고온 진공 환경에서 불소와 산소 플라즈마 라디칼에 노출되는 경우 씰링은 플라즈마 공격으로 인한 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("침식 속도와 무게 감소")]), _vm._v("가 극히 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("낮으며")]), _vm._v(" 암모니아, 오존 및 수증기에 대한 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("우수한 화학 저항성")]), _vm._v("을 제공")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("Olive- Green")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "color": "#89AC23",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-9600.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("70")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("315 (599)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("15")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("9500")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("SACVD, FCVD, PECVD 공정 오존, 암모니아 및 수증기가 발생되는 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("증착 공정")]), _vm._v("에 적합")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("Tan")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "color": "#FABA86",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-9500.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("76")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("310 (590)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("20")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("9300")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("Dielectric Etch (산화물 에칭)에 사용하며 산소와 불소 기반의 플라즈마 및 내화학성 우수")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("Brown")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "color": "#800000",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-9300.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("77")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("300 (572)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("25")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("9100")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("ALD, HDPCVD, Conductor Etch 에 적합 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("플라즈마 환경")]), _vm._v("에서 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("낮은 용출")]), _vm._v(" 및 초 저 입자 생성")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("Amber")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "color": "#FFCC00",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-9100.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("77")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("300 (572)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("18")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("8002")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("Ash / Strip 공정에 사용하기 위한 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("투명 제품")]), _vm._v("이며 무기물질첨가제가 포함된 제품 대비산소 및 불소 기반의 플라즈마에서 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("우수한 Crack 저항")]), _vm._v("과초 저 미세 입자 생성")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("Clear")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "color": "#D9D9D9",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-8002.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("69")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("275 (527)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("12")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("8705")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("플라즈마에서 방출되는 고 에너지 자외선으로 인한 고농도의 유해 산소 자유 라디칼에대한 내화학성과 고온 진공에서도 우수한씰링 기능을 보여줌")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("Black")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "color": "#000",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-8705.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("77")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("327 (621)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("24")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("8900")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("산화, ALD, LPCVD와 같은 고온에서 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("물리적 특성")]), _vm._v("을 우수하게 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("유지")]), _vm._v("하며, 뛰어난 강도를 지니고 있어 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("정적 및 동적 실링")]), _vm._v(" 분야에 모두 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("적합")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("Black")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "color": "#000",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-8900.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("76")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("325 (617)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("20")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("8575")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("산화, Lamp Anneal, RTP와 같은 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("고온")]), _vm._v("에서 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("매우 낮은 IR")]), _vm._v("(적외선) "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("흡수")]), _vm._v(" 및 아웃 가싱 특성을 나타냄")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("White")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8 border border-2",
    attrs: {
      "color": "#fff",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-8575.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("63")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("300 (572)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("25")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("7075 UP")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("Metal, CVD와 같은 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("뛰어난 열 안정성")]), _vm._v(" (327℃), Kalrez®7075 UP으로 만든 제품은 초 순수 후 처리 가능")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("Black")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "color": "#000",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-7075-up.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("75")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("327 (621)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("13")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("9500")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("높은 열 안정성, 매우 낮은 배출가스 및 우수한 강성을 지니며 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("정적 및 동적 씰링")]), _vm._v(" 분야에 모두 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("적합")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("Tan")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "color": "#FABA86",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-9500.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("76")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("310 (590)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("18")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("9600")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("높은 온도 조건에서의 뛰어난 압축 탄력성과 초 저 진공에서의 우수한 저 가스성으로 인해 순도가 매우 중요한 분야에 적합")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "w-100"
  }, [_vm._v("Olive- Green")]), _c('v-avatar', {
    staticClass: "mt-6 mt-md-8",
    attrs: {
      "color": "#89AC23",
      "size": "24"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-40px w-md-130px",
    attrs: {
      "src": "/images/sub/distributor/kalrez/kalrez-9600-2.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("70")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("315 (599)")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("12")])])])])])])])], 1)], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    staticClass: "mb-40 mb-lg-60",
    attrs: {
      "tit": "Kalrez® 공정별 추천 재질"
    }
  }, [_c('h5', {
    staticClass: "font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium"
  }, [_vm._v("Plasma Process")]), _c('table', {
    staticClass: "client-table client-table-lg w-100 word-break-word word-sm-keep-all mb-40 mb-lg-60"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "border-end w-md-17"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Process Type")])]), _c('th', {
    staticClass: "border-end w-md-26"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Process Remark")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Maximum Service Temperature")])]), _c('th', {
    staticClass: "border-end w-md-28"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Typical Chemistries")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Suggested Product")])])])]), _c('tbody', [_c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v("HDPCVD")]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-13 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("High-Density Plasma "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("Chemical Vapor Deposition")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("고밀도 플라즈마 화학 기상 증착법")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("250℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("300℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v("TMS를 적용하여 웨이퍼 표면의 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("유기 잔류물")]), _vm._v("을 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("용해")]), _vm._v("시켜 제거하는 용도")]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-13 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("DEMS, TEOS, SiH₄, SiF₄, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("NH₃, O₂, N₂O, C₄F₈, NF₃")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 9100 / 9500")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v("PECVD / PEALD")]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-13 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("Plasma-Enhanced "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("Atomic Layer Deposition")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("플라즈마 증강 원자 층 증착")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("275℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("310℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v("TMS, DEMS, TEOS 사용 TMS, 전기화학적 질량 분석법, SiO₂중착 사용")]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("SiH₄, SiF₄, NH₃, O₂, N₂O, C₄F₈, NF₃")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 9600")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v(" PECVD"), _c('br'), _vm._v(" Curing Process ")]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("Plasma-Enhanced "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("Chemical Vapor Deposition")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("플라즈마 증강 화학 기상 증착 기술을 활용한 코팅 및 경화 공정")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("150℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("200℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v("O₃ + UV Light")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 8705 / 9500")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v("SACVD / FCVD")]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("Sub-Atmospheric Chemical Vapor Deposition")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("부분 진공 환경에서 화학 기상 증착 기술을 활용한 층 증착 기술")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("280℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("300℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v(" TEP"), _c('br'), _vm._v(" 금속 이온을 생성하기 위한 환원제 ")]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("NH₃, O₃, NF₃")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 9500 / 9600")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v("Conductor Etch")]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("Poly / Metal")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("전도체 층을 제거하는 기술")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("150℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("225℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v("CF₄, CHF₃, HBr, BCl₃, CCl₄, Cl₂, NF₃")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 9100 / 9300")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v("Dielectric Etch")]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("Oxide")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("산화물과 같은 절연체 층을 제거하는 기술")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("100℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("180℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v("CF₄, C₃F₈, CHF₃, SF₆, O₂, H₂")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 9300")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v("Ash / Strip")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left"
  }, [_c('p', [_vm._v("Ash 층 표면의 유기물을 제거하는 공정 / Strip 공정은 산화물을 제거하기 위한 공정")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("180℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("250℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v("CF₄, CHF₃, O₂, NH₃, Water Vapor, H₂, Forming Gas")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 9300 / 8002")])])])])])]), _c('h5', {
    staticClass: "font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium"
  }, [_vm._v("Thermal Process")]), _c('table', {
    staticClass: "client-table client-table-lg w-100 word-break-word word-sm-keep-all mb-40 mb-lg-60"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "border-end w-md-17"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Process Type")])]), _c('th', {
    staticClass: "border-end w-md-26"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Process Remark")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Maximum Service Temperature")])]), _c('th', {
    staticClass: "border-end w-md-28"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Typical Chemistries")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Suggested Product")])])])]), _c('tbody', [_c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v(" ALD, LPCVD, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" Metal CVD ")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left flex-wrap line-height-135"
  }, [_c('div', [_c('div', [_vm._v("원자층 증착법 (ALD)")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 font-weight-regular grey--text"
  }, [_vm._v("기체 전자로부터 층을 쌓아 올리는 방식")])]), _c('div', {
    staticClass: "mt-6 mt-md-8"
  }, [_c('div', [_vm._v("저압 화학 기상 증착 (LPCVD)")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 font-weight-regular grey--text"
  }, [_vm._v(" 가스 혼합물을 진공 상태에서 고온으로 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 반응시켜 기판 표면에 고체 필름을 생성 ")])]), _c('div', {
    staticClass: "mt-6 mt-md-8"
  }, [_c('div', [_vm._v("금속 증착법 (Metal CVD)")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 font-weight-regular grey--text"
  }, [_vm._v(" 가스 혼합물을 진공 상태에서 고온으로 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 반응시켜 기판 표면에 고체 필름을 생성 ")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("250℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("300℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v(" WF₆, TiCl₄, HF, SiF₄, F₂, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" N₂O Vapor, Cl₂, ClF₃ ")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 7075 UP / 8900")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v(" Oxidation, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" Nitridation, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" Diffusion ")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left flex-wrap line-height-135"
  }, [_c('div', [_c('div', [_vm._v("산화 공정 (Oxidation)")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 font-weight-regular grey--text"
  }, [_vm._v("산소 원자를 삽입하여 산화막을 형성하는 과정")])]), _c('div', {
    staticClass: "mt-6 mt-md-8"
  }, [_c('div', [_vm._v("질화 공정 (Niridation)")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 font-weight-regular grey--text"
  }, [_vm._v("질소를 삽입하여 질화막을 형성하는 과정")])]), _c('div', {
    staticClass: "mt-6 mt-md-8"
  }, [_c('div', [_vm._v("확산 공정(Diffusion)")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 font-weight-regular grey--text"
  }, [_vm._v("불순물을 반도체 소자의 표면에서 내부로 이동시키는 과정")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("250℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("300℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v(" O₂, N₂, N₂O Vapor, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" Cl₂, O₃, HCl ")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 7075 UP / 8900")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v(" Lamp Anneal, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" RTP ")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left flex-wrap line-height-135"
  }, [_c('p', [_c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("빛")]), _vm._v("을 쬐어 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("고온의 가열")]), _vm._v("로 인해 물질 구조의 결정성을 증가, "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("1000℃ 이상")]), _vm._v(" 유지하여 반도체 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("소자의 특성을 개선")])]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("(불순물 확산, 불순물 활성화, 산화, 질화) ")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("250℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("275℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v(" Infrared Light, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" N₂O Vapor, O₂ ")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 8575")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v(" Wafer Surface "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" Preparation ")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left flex-wrap line-height-135"
  }, [_c('p', [_vm._v("반도체 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("웨이퍼 표면")]), _vm._v("을 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("깨끗")]), _vm._v("하고 매끄럽게 만들어 다음 공정에 적용할 수 있도록 하는 과정")]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("(Etching, Cleaning, CMP)")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("250℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("275℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', [_vm._v("NH₃, H₂, F₂, NF₃, HF")])])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("Kalrez® 9500 / 9600")])])])])])]), _c('h5', {
    staticClass: "font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium"
  }, [_vm._v("Wet Process")]), _c('table', {
    staticClass: "client-table client-table-lg w-100 word-break-word word-sm-keep-all"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "border-end w-md-17"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Process Type")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Maximum Service Temperature")])]), _c('th', {
    staticClass: "border-end w-md-28"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Typical Chemistries")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Suggested Product")])])])]), _c('tbody', [_c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v("Wafer Preparation")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("70℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("125℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left flex-wrap line-height-135"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('div', [_vm._v("UPW")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 grey--text"
  }, [_vm._v("(Ultra-Pure Water) 초순수 물")])]), _c('div', {
    staticClass: "w-100 mt-6 mt-md-8"
  }, [_c('div', [_vm._v("Piranha")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 grey--text"
  }, [_vm._v("황산과 과산화수소의 혼합물1")])]), _c('div', {
    staticClass: "w-100 mt-6 mt-md-8"
  }, [_c('div', [_vm._v("SC-1, SC-2, O₃")])]), _c('div', {
    staticClass: "w-100 mt-6 mt-md-8"
  }, [_c('div', [_vm._v("EKC fluids")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 grey--text"
  }, [_vm._v("(Electronic Grade Chemicals) 고순도 화학 액체")])])])]), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_c('div', {
    staticClass: "table-inner left flex-wrap line-height-135"
  }, [_c('div', {
    staticClass: "w-100 font-weight-bold"
  }, [_vm._v("Kalrez® W240UP")]), _c('p', {
    staticClass: "w-100 mt-6 mt-md-8"
  }, [_c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("화학적 저항성")]), _vm._v("이 필요한 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("필터, 밸브, 펌프")]), _vm._v(" 등에 쓰이는 오링으로 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 색상은 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("검은색")]), _vm._v("을 나타냅니다. ")]), _c('p', {
    staticClass: "w-100 mt-6 mt-md-8"
  }, [_c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("산/알칼리")]), _vm._v("에 대한 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("저항성,")]), _vm._v(" "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 고 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("습윤 공정용")]), _vm._v(" 제품으로 선호되며 ")]), _c('p', {
    staticClass: "w-100 mt-6 mt-md-8"
  }, [_vm._v(" 제조 후, 초순수 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("세정 공정")]), _vm._v("을 통하여 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 제품에 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("Particle")]), _vm._v("이 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("거의 없습니다.")])])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v("Etching")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("70℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("95℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left flex-wrap line-height-135"
  }, [_c('p', [_vm._v("HNO₃, HF₂, H₂O, H₃PO₄, NH₄OH")]), _c('span', {
    staticClass: "font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8"
  }, [_vm._v("[ 질산, 이중 염산, 물, 인산, 수산화 암모늄 ]")])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v("Stripping")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("70℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("125℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left flex-wrap line-height-135"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('div', [_vm._v("NMP")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 grey--text"
  }, [_vm._v("(N-Methyl-2-Pyrrolidone) 산화막 및 layer 제거 공정에 사용")])]), _c('div', {
    staticClass: "w-100 mt-6 mt-md-8"
  }, [_c('div', [_vm._v("Alkanolamine")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 grey--text"
  }, [_vm._v("에칭, 산화 제거, 세정에 사용")])]), _c('div', {
    staticClass: "w-100 mt-6 mt-md-8"
  }, [_c('div', [_vm._v("Hydroxylamine")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 grey--text"
  }, [_vm._v("전자 빔 증착 공정 후, 표면에 남은 유기 잔여물 제거에 사용")])]), _c('div', {
    staticClass: "w-100 mt-6 mt-md-8"
  }, [_c('div', [_vm._v("Acetone / IPA")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 grey--text"
  }, [_vm._v("유/무기 오염 물질을 제거")])]), _c('div', {
    staticClass: "w-100 mt-6 mt-md-8"
  }, [_c('div', [_vm._v("EKC 265")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 grey--text"
  }, [_vm._v("(Electronic Grade Chemicals) 부식 및 오염 제거를 위해 사용되는 알칼리성 용액")])])])])]), _c('tr', [_c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner flex-wrap"
  }, [_c('p', {
    staticClass: "line-height-12 w-100"
  }, [_vm._v("Copper Plating")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('p', [_vm._v("70℃ ~ "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("125℃")])])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner left flex-wrap line-height-135"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('div', [_vm._v("CuSO₄ Solution, H₂SO₄")]), _c('p', {
    staticClass: "font-size-10 font-size-md-12 grey--text"
  }, [_vm._v("[ 구리 황산염 용액 – Etching Fluid, 웨이퍼 표면 산화물 제거]")])])])])])])])])], 1)], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "Kalrez® Groove"
    }
  }, [_c('p', {
    staticClass: "page-text color-grey-51 mb-30 mb-lg-52"
  }, [_vm._v("새로운 장비를 개발하거나 Viton O-ring에서 Kalrez O-ring으로 변경했을 때, 문제가 발생했다면 O-ring Groove는 검토 해야 할 대상 중 하나입니다. Kalrez는 Viton보다 높은 열팽창 특성을 가지기 때문에 이를 고려하지 않고 Groove 변경 없이 고온에서 사용할 경우 Crack 또는 Extrusion 현상이 발생할 수 있습니다.")]), _c('h5', {
    staticClass: "font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium"
  }, [_vm._v("Rectangular Groove for Static Application")]), _c('table', {
    staticClass: "client-table client-table-lg w-100 word-break-word word-sm-keep-all mb-40 mb-lg-60"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "border-end w-md-80px"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Code Name")])]), _c('th', {
    staticClass: "border-end w-md-220px"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Product Drawing")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Code No.")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("CSD")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Temp.(℃)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Width(G)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Depth(H)")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Radius(R)")])])])]), _c('tbody', [_c('tr', [_c('th', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "6"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("AS568A")])]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "6"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-100px w-md-198px",
    attrs: {
      "max-width": "198",
      "src": "/images/sub/distributor/kalrez/groove-rectangular.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("102 ~ 178")])]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2.62± "), _c('span', {
    staticClass: "font-size-10 font-size-md-12"
  }, [_vm._v("0.08")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 180")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3.20")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2.00")])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.40")])])]), _c('tr', [_c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 250")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3.55")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2.00")])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.40")])])]), _c('tr', [_c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("201 ~ 284")])]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3.53±"), _c('span', {
    staticClass: "font-size-10 font-size-md-12"
  }, [_vm._v("0.10")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 180")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.40")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2.85")])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.60")])])]), _c('tr', [_c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 250")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.80")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2.85")])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.60")])])]), _c('tr', [_c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("309 ~ 395")])]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("5.33±"), _c('span', {
    staticClass: "font-size-10 font-size-md-12"
  }, [_vm._v("0.13")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 180")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("6.50")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.30")])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.90")])])]), _c('tr', [_c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 250")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("7.15")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.30")])]), _c('td', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.90")])])])])]), _c('h5', {
    staticClass: "font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium"
  }, [_vm._v("Dovetail Groove for Application")]), _c('table', {
    staticClass: "client-table client-table-lg w-100 word-break-word word-sm-keep-all"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "border-end w-md-80px"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Code Name")])]), _c('th', {
    staticClass: "border-end w-md-220px"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Product Drawing")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Code No.")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("CSD")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Temp.(℃)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Top Width to Sharps (G`)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Top Width (G)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Depth (H)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Top Radius (R1)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Bottom Radius (R1)")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Side Wall Angle")])])])]), _c('tbody', [_c('tr', [_c('th', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "6"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("AS568A")])]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "6"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-100px w-md-198px",
    attrs: {
      "max-width": "198",
      "src": "/images/sub/distributor/kalrez/groove-dovetail.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("201~284")])]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3.53±"), _c('span', {
    staticClass: "font-size-10 font-size-md-12"
  }, [_vm._v("0.10")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 180")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2.98")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3.20")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2.85")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.20")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.80")])]), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.80")])])]), _c('tr', [_c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 250")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3.53")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3.75")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2.85")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.20")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.80")])])]), _c('tr', [_c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("201~284")])]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("5.33±"), _c('span', {
    staticClass: "font-size-10 font-size-md-12"
  }, [_vm._v("0.13")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 180")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.47")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.90")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.30")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.40")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.80")])])]), _c('tr', [_c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 250")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.77")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("5.20")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.30")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.40")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.80")])])])])]), _c('p', {
    staticClass: "font-size-12 font-size-md-14 mt-8 mt-lg-10 mb-40 mb-lg-60"
  }, [_vm._v("*Dovetail Design을 적용한 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("Dynamic")]), _vm._v(" 부위면서 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("250℃")]), _vm._v(" 이상인 공정 조건에 적용 시 Static 을 적용한 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("수명")]), _vm._v("보다 "), _c('span', {
    staticClass: "color-point font-weight-bold"
  }, [_vm._v("줄어들 수 있음")])]), _c('h5', {
    staticClass: "font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium"
  }, [_vm._v("Half-Dovetail Groove for Static Application")]), _c('table', {
    staticClass: "client-table client-table-lg w-100 word-break-word word-sm-keep-all"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "border-end w-md-80px"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Code Name")])]), _c('th', {
    staticClass: "border-end w-md-220px"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Product Drawing")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Code No.")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("CSD")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Temp.(℃)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Top Width to Sharps (G`)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Top Width (G)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Depth (H)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Top Radius (R1)")])]), _c('th', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Bottom Radius (R1)")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Side Wall Angle")])])])]), _c('tbody', [_c('tr', [_c('th', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "6"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("AS568A")])]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "6"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_c('v-img', {
    staticClass: "w-100px w-md-198px",
    attrs: {
      "max-width": "198",
      "src": "/images/sub/distributor/kalrez/groove-half-dovetail.png"
    }
  })], 1)]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("201~284")])]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3.53±"), _c('span', {
    staticClass: "font-size-10 font-size-md-12"
  }, [_vm._v("0.10")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 180")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3.79")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("3.90")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2.85")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.20")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.80")])]), _c('td', {
    attrs: {
      "rowspan": "4"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("24°")])])]), _c('tr', [_c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 250")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.19")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.30")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("2.85")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.20")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.80")])])]), _c('tr', [_c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("201~284")])]), _c('td', {
    staticClass: "border-end",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("5.33±"), _c('span', {
    staticClass: "font-size-10 font-size-md-12"
  }, [_vm._v("0.13")])])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 180")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("5.49")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("5.60")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.30")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.20")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.80")])])]), _c('tr', [_c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("≤ 250")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("6.09")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("6.20")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("4.30")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.20")])]), _c('td', {
    staticClass: "border-end"
  }, [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("0.80")])])])])])])], 1)], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "Kalrez® 규격"
    }
  }, [_c('p', {
    staticClass: "page-text color-grey-51 mb-14 mb-lg-16"
  }, [_vm._v("Kalrez®부품은 AS-568, Metric, JIS, NW 규격에 따른 O-Ring 재고를 보유 중이며 반도체, Display 공정 등 다양한산업에 필요한 재고를 확보하고 있어 고객의 요청 사항에 맞춰 신속한 대응이 가능합니다.")]), _c('div', {
    staticClass: "page-text font-weight-medium mb-40 mb-lg-60"
  }, [_vm._v("표준규격 Kalrez® List를 다운로드 받아 규격 별 리스트를 확인하실 수 있습니다.")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "href": "/assets/document/IST_Dupont Kalrez List-Up.pdf",
      "download": ""
    }
  }, [_vm._v("표준 규격 Kalrez® List 다운로드")])], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('inquiry', {
    attrs: {
      "src": "/images/sub/distributor/dupont/dupont-img1.png",
      "name": "황 명 선",
      "tel": "031-765-2268",
      "mail": "mshwang@ist-co.kr",
      "fax": "031-765-2389",
      "link": "https://www.dupont.com/kalrez.html",
      "linkBg": "/images/sub/distributor/dupont/dupont-img2.png"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }